import { ButtonHTMLAttributes, ReactNode } from 'react';
import clsx from 'clsx';

type Variant = 'primary' | 'secondary' | 'ghost';
type Size = 'sm' | 'md';

const base = 'inline-flex items-center justify-center font-medium tracking-tight transition-[background,border,color] duration-[120ms] ease-out disabled:opacity-40 disabled:cursor-not-allowed select-none';
const variants: Record<Variant, string> = {
  primary:   'bg-ink text-bg hover:bg-[#1f1f1f]',
  secondary: 'bg-bg text-ink hairline hover:bg-whisper',
  ghost:     'bg-transparent text-ink hover:bg-whisper',
};
const sizes: Record<Size, string> = {
  sm: 'h-9 sm:h-7 px-2.5 sm:px-2 text-sm rounded-sm',
  md: 'h-11 sm:h-9 px-3 text-base rounded-sm',
};

export function Button({
  variant = 'secondary',
  size = 'md',
  className,
  children,
  iconLeft,
  iconRight,
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant;
  size?: Size;
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
}) {
  return (
    <button className={clsx(base, variants[variant], sizes[size], className)} {...rest}>
      {iconLeft && <span className="mr-1 flex">{iconLeft}</span>}
      {children}
      {iconRight && <span className="ml-1 flex">{iconRight}</span>}
    </button>
  );
}
